import React, { useEffect, Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ContactsProvider } from './contexts/ContactsContext';
import { MessagesProvider } from './contexts/MessagesContext';
import { CartProvider } from './contexts/CartContext';
import { WalletProvider } from './contexts/WalletContext';
import { NotificationsProvider } from './contexts/NotificationsContext';
import { IntegrationsProvider } from './contexts/IntegrationsContext';
import { ToastProvider } from './contexts/ToastContext';
import { ToastContainer } from 'react-toastify';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import 'react-toastify/dist/ReactToastify.css';
import { Toaster } from 'react-hot-toast';
import ErrorBoundary from './components/ErrorBoundary';
import { initializeCronJobs } from './utils/cronJobs/initializeCronJobs';
import { setupOrderStatusListener } from './services/stockManagement';
import AppRoutes from './routes';
import FloatingChat from './components/chat/FloatingChat';
import { useAuth } from './contexts/AuthContext';
import { ShopifyRedirect } from './pages/ShopifyRedirect';
import { ShopifyCallback } from './pages/ShopifyCallback';

function App() {
  useEffect(() => {
    // Inicializar tarefas cron 
    initializeCronJobs().catch(console.error);

    // Iniciar listener de ordens
    const unsubscribe = setupOrderStatusListener(import.meta.env.VITE_COMPANY_ID || '');

    return () => {
      if (unsubscribe) {
        unsubscribe();
      }
    };
  }, []);

  return (
    <>
      <Toaster position="top-right" />
      <ErrorBoundary>
        <Router>
          <AuthProvider>
            <NotificationsProvider>
              <ContactsProvider>
                <MessagesProvider>
                  <CartProvider>
                    <WalletProvider>
                      <IntegrationsProvider>
                        <ToastProvider>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <Routes>
                              <Route path="/*" element={<AppRoutes />} />
                              {/* Rotas do Shopify */}
                              <Route path="/dashboard/multicanal/shopify/redirect" element={<ShopifyRedirect />} />
                              <Route path="/dashboard/multicanal/shopify/callback" element={<ShopifyCallback />} />
                            </Routes>
                            <FloatingChat />
                          </LocalizationProvider>
                        </ToastProvider>
                      </IntegrationsProvider>
                    </WalletProvider>
                  </CartProvider>
                </MessagesProvider>
              </ContactsProvider>
            </NotificationsProvider>
          </AuthProvider>
        </Router>
      </ErrorBoundary>
      <ToastContainer 
        position="bottom-right"
        autoClose={3000}
        hideProgressBar={false}
        closeOnClick
        pauseOnHover
      />
    </>
  );
}

export default App;